var map = {
	"./skins/IBC-dyst": [
		195,
		20
	],
	"./skins/IBC-dyst-2025": [
		194,
		21
	],
	"./skins/IBC-dyst-2025.css": [
		555,
		45
	],
	"./skins/IBC-dyst-2025.js": [
		194,
		21
	],
	"./skins/IBC-dyst.css": [
		556,
		44
	],
	"./skins/IBC-dyst.js": [
		195,
		20
	],
	"./skins/aktionaerliga-2024": [
		196,
		19
	],
	"./skins/aktionaerliga-2024.css": [
		557,
		43
	],
	"./skins/aktionaerliga-2024.js": [
		196,
		19
	],
	"./skins/aktionaerliga-2025": [
		197,
		18
	],
	"./skins/aktionaerliga-2025.css": [
		558,
		42
	],
	"./skins/aktionaerliga-2025.js": [
		197,
		18
	],
	"./skins/bibliotekarernes-sep-2024": [
		198,
		17
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		559,
		41
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		198,
		17
	],
	"./skins/boersen-spiel-sep-2024": [
		199,
		16
	],
	"./skins/boersen-spiel-sep-2024.css": [
		560,
		40
	],
	"./skins/boersen-spiel-sep-2024.js": [
		199,
		16
	],
	"./skins/borsgruppenliu-jan-2024": [
		200,
		15
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		561,
		39
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		200,
		15
	],
	"./skins/eadania": [
		201,
		14
	],
	"./skins/eadania.css": [
		562,
		38
	],
	"./skins/eadania.js": [
		201,
		14
	],
	"./skins/fynske-bank-sep-2024": [
		202,
		13
	],
	"./skins/fynske-bank-sep-2024.css": [
		563,
		37
	],
	"./skins/fynske-bank-sep-2024.js": [
		202,
		13
	],
	"./skins/ibc-jan-2024": [
		203,
		22
	],
	"./skins/ibc-jan-2024.js": [
		203,
		22
	],
	"./skins/rosborg-gym-2026": [
		204,
		12
	],
	"./skins/rosborg-gym-2026.css": [
		564,
		36
	],
	"./skins/rosborg-gym-2026.js": [
		204,
		12
	],
	"./skins/sdu-businessschooldays-2024": [
		205,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		565,
		35
	],
	"./skins/sdu-businessschooldays-2024.js": [
		205,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		206,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		566,
		34
	],
	"./skins/sdu-businessschooldays-2025.js": [
		206,
		10
	],
	"./skins/skoledyst-oct-2023": [
		207,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		567,
		33
	],
	"./skins/skoledyst-oct-2023.js": [
		207,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		208,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		568,
		32
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		208,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		209,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		569,
		31
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		209,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		210,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		570,
		30
	],
	"./skins/sommerdysten-ad-2023.js": [
		210,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		211,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		571,
		29
	],
	"./skins/sommerdysten-ak-2023.js": [
		211,
		5
	],
	"./skins/sommerdysten-is-2023": [
		212,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		572,
		28
	],
	"./skins/sommerdysten-is-2023.js": [
		212,
		4
	],
	"./skins/sydbank-sep-2020": [
		213,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		573,
		27
	],
	"./skins/sydbank-sep-2020.js": [
		213,
		3
	],
	"./skins/targo-2025": [
		214,
		2
	],
	"./skins/targo-2025.css": [
		574,
		26
	],
	"./skins/targo-2025.js": [
		214,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		215,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		575,
		25
	],
	"./skins/ung_aktiedyst_2025.js": [
		215,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		216,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		576,
		24
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		216,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 361;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 361
// module chunks = 46